module.exports = __webpack_public_path__ + "img/circle.18f5a39c.svg";